const formato = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 4 })

export function percentualFiscal(v: number | null | undefined): string {
  return v == null ? 'não informado' : `${formato.format(v)}%`
}

// Sem legenda nenhuma no ST (decisao dela, 24/09: "0% ja diz tudo, a frase
// polui a tela"). Nunca "Isento": isento e aliquota zero sao coisas diferentes.
